import { render, staticRenderFns } from "./InformedConsent.vue?vue&type=template&id=e54687de"
import script from "./InformedConsent.vue?vue&type=script&lang=js"
export * from "./InformedConsent.vue?vue&type=script&lang=js"
import style0 from "./InformedConsent.vue?vue&type=style&index=0&id=e54687de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports